import PromotionRequests from '../../server/promotion';
import { addLoading, removeLoading } from './loading';

export const setPromotions = promotions => ({
  type: 'PANEL_PROMOTIONS_GET',
  promotions,
});

const createPromotion = promotion => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PromotionRequests.createPromotion(promotion);
  } finally {
    dispatch(removeLoading());
  }
};

const updatePromotion = promotion => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PromotionRequests.updatePromotion(promotion);
  } finally {
    dispatch(removeLoading());
  }
};

const getPromotions = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const promotion = await PromotionRequests.getPromotions(limit, skip, search, order, field);
    dispatch(setPromotions(promotion));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

const removePromotion = records => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PromotionRequests.removePromotion(records);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvPromotionModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PromotionRequests.getCsvPromotionModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvPromotionsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PromotionRequests.getCsvPromotionsReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadPromotions = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await PromotionRequests.uploadCsvPromotions(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createPromotion,
  getPromotions,
  removePromotion,
  updatePromotion,
  getCsvPromotionModel,
  getCsvPromotionsReport,
  uploadPromotions,
};
